/* @flow */
import { Component } from "react";
import throttle from "lodash/throttle";

import type { Node } from "react";

type State = {
  width: number,
  height: number
};

type Props = {
  children: (config: State) => Node
};

class Dimensions extends Component<Props, State> {
  state = {
    height: window.innerHeight,
    width: window.innerWidth
  };

  handleSizeChange = () => {
    this.setState({
      height: window.innerHeight,
      width: window.innerWidth
    });
  };

  throttleSizeChange = throttle(() => this.handleSizeChange(), 300);

  componentDidMount() {
    window.addEventListener("resize", this.throttleSizeChange, false);
    window.addEventListener(
      "orientationchange",
      this.throttleSizeChange,
      false
    );
  }

  componentWillUnmount() {
    window.removeEventListener("orientationchange", this.throttleSizeChange);
    window.removeEventListener("resize", this.throttleSizeChange);
  }

  render() {
    if (typeof this.props.children !== "function") {
      return null;
    }

    return this.props.children({ ...this.state });
  }
}

export default Dimensions;



// WEBPACK FOOTER //
// ./src/components/TradeMobile/Dimensions.js